<script>
import { BTabs, BTab } from 'bootstrap-vue';
export default {
  name: 'AppImageSlideshow',


  props: {
    images: { type: Array, default: () => ([]) },
    align: { type: String, default: 'center' },
  },

  components: {
    BTabs,
    BTab,
  },

  data() {
    return {
      activeImages: 0,
    }
  },
}
</script>

<template>
  <div class="text-center">
    <div v-if="!images.length" class="p-1">
      <img
        src="/assets/images/placeholder-square.webp"
        alt="slideshow-image"
        width="280px"
        height="280px"
        class="img-fluid rounded-circle"
      />
    </div>

    <div v-else>
      <!-- View Photo -->
      <div class="mb-4 p-3" :style="{ minHeight: '280px' }">
        <img
          :src="images[activeImages]"
          :alt="images[activeImages]"
          width="280px"
          height="280px"
          class="img-fluid"
        />
      </div>

      <!-- Photos Tab -->
      <b-tabs
        v-if="images.length > 1"
        v-model="activeImages"
        pills
        end
        nav-class="app-slideshow-image-tab"
        active-nav-item-class="bg-light"
        class="p-1"
        :align="align"
      >
        <b-tab
          v-for="(image, key) in images"
          :key="key"
          title-link-class="p-0 rounded"
        >
          <template #title>
            <div class="slideshow-image">
              <img
                :src="image"
                :alt="`slideshow-image-${key}`"
                class="object-cover"
                width="100%"
                height="100%"
              />
            </div>
          </template>
        </b-tab>
      </b-tabs>
    </div>

    <slot></slot>
  </div>
</template>

<style lang="scss">
.app-slideshow-image-tab {
  .slideshow-image {
    width: 69px;
    height: 71px;

    img {
      vertical-align: middle;
    }
  }

  .nav-item:not(:last-child) {
    padding-right: 10px;
  }

  // FIX: Remove after enclosing parent styling for .nav-item class
  .nav-item {
    border-bottom: none !important;
  }
}
</style>
